import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import { deepGet } from '../../shared/utils'
import ListEntry from './ListEntry'

@inject('auth')
@observer
export default
class List extends Component {

  static propTypes = {
    auth: PropTypes.object,
    filter: PropTypes.object,
    program: PropTypes.object,
  }

  render() {

    const { program, auth, filter } = this.props

    const list = program.collection
      .filter((currProgram) => {
        if (!filter) {
          return true
        }
        return Object.keys(filter).reduce((memo, key) => {
          return memo && currProgram[key] === filter[key]
        }, true)
      })

    const currentUserMuseum = deepGet(auth, 'user.museumId')

    return (
      <ul
        className="nav-list"
      >
        {
          (list || [])
            .filter((currProgram) => currProgram.museum.id === currentUserMuseum)
            .map((currProgram) => (
              <ListEntry
                editable={currProgram.museum.id === currentUserMuseum}
                key={currProgram.id}
                program={currProgram}
              />
            ))
        }

      </ul>
    )
  }

}



// WEBPACK FOOTER //
// ./src/program/components/SimpleList.js